import React, { Component } from 'react'
import { Slide } from 'react-slideshow-image'
import 'react-slideshow-image/dist/styles.css'
import '../styles/Slider.css'
import Image1 from './Images/image1.jpg';
import Image2 from './Images/image2.jpg';
import Image3 from './Images/image8.jpg';
import Image4 from './Images/image4.jpg';

export class Slider extends Component {
    constructor(props) {
        super(props)
        this.state = {
            slideDivs: [
                Image1,
                Image2,
                Image3,
                Image4,
            ],
        }
    }

    render() {
        const { slideDivs } = this.state;
        const properties = {
            duration: 5000,
            transitionDuration: 1000,
            infinite: true,
            indicators: true,
            arrows: true
        }
        return (
            <div className="slide-container">
                <Slide {...properties}>

                    <div className="each-slide">
                        <div className="background" style={{ 'backgroundImage': `url(${slideDivs[0]})` }}>
                            <span>Hiking at Elephant Hill Aberdare</span>
                        </div>
                    </div>
                    <div className="each-slide">
                        <div className="background" style={{ 'backgroundImage': `url(${slideDivs[1]})` }}>
                            <span>Nachu Caves</span>
                        </div>
                    </div>
                    <div className="each-slide">
                        <div className="background" style={{ 'backgroundImage': `url(${slideDivs[2]})` }}>
                            <span>Longonot</span>
                        </div>
                    </div>
                    <div className="each-slide">
                        <div className="background" style={{ 'backgroundImage': `url(${slideDivs[3]})` }}>
                            <span>Nachu Caves</span>
                        </div>
                    </div>

                </Slide>
            </div>
        )
    }
}

export default Slider
